import { langTypeSchema } from '@server/schemas'
import { useTranslation } from '@shared/config/i18n'
import { z } from 'zod'

import { ChipV2, HStack } from '@podo-app/design-system-temp'

type Props = {
  selectedLanguage: z.infer<typeof langTypeSchema>
  handleChangeLanguage: (language: z.infer<typeof langTypeSchema>) => void
  excludeLanguages?: z.infer<typeof langTypeSchema>[]
}

const SubscribeTicketLanguageChip = ({ selectedLanguage, handleChangeLanguage, excludeLanguages = [] }: Props) => {
  const t = useTranslation()

  return (
    <HStack className="gap-2">
      {!excludeLanguages.includes('EN') && (
        <ChipV2 className="flex-1" selected={selectedLanguage === 'EN'} onClick={() => handleChangeLanguage('EN')}>
          {t('subscribeList.chip.languageEn')}
        </ChipV2>
      )}
      {!excludeLanguages.includes('JP') && (
        <ChipV2 className="flex-1" selected={selectedLanguage === 'JP'} onClick={() => handleChangeLanguage('JP')}>
          {t('subscribeList.chip.languageJa')}
        </ChipV2>
      )}
      {!excludeLanguages.includes('ENJP') && (
        <ChipV2 className="flex-1" selected={selectedLanguage === 'ENJP'} onClick={() => handleChangeLanguage('ENJP')}>
          {t('subscribeList.chip.languageEnJa')}
        </ChipV2>
      )}
    </HStack>
  )
}

export default SubscribeTicketLanguageChip
